<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'BANKS.BANK_ACCOUNTS.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([], ['bank_accounts.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'BANKS.BANK_ACCOUNTS.ADD' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="bankAccountsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'BankAccounts', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'BANKS.BANK_ACCOUNTS.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'BANKS.BANK_ACCOUNTS.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="bankaccountable.abbreviation"
      title="{{ 'BANKS.BANK_ACCOUNTS.COMPANY' | translate }}"
      filter="text"
      [width]="150"
      [hidden]="isHiddenColumn('bankaccountable.abbreviation')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter" [field]="'bankaccountable_id'"></app-kendo-company-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="abbreviation"
      title="{{ 'BANKS.BANK_ACCOUNTS.ABBREVIATION' | translate }}"
      filter="text"
      [width]="120"
      [hidden]="isHiddenColumn('abbreviation')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'BANKS.BANK_ACCOUNTS.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="currency.code"
      [width]="100"
      title="{{ 'BANKS.BANK_ACCOUNTS.CURRENCY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('currency.code')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="balance"
      [width]="120"
      title="{{ 'BANKS.BANK_ACCOUNTS.BALANCE' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('balance')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="account_number"
      title="{{ 'BANKS.BANK_ACCOUNTS.ACCOUNT_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('account_number')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="address"
      title="{{ 'BANKS.BANK_ACCOUNTS.ADDRESS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('address')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="beneficiary_name"
      title="{{ 'BANKS.BANK_ACCOUNTS.BENEFICIARY_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('beneficiary_name')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="bic"
      title="{{ 'BANKS.BANK_ACCOUNTS.BIC' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('bic')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="iban"
      title="{{ 'BANKS.BANK_ACCOUNTS.IBAN' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('iban')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [width]="100"
      field="sort_code"
      title="{{ 'BANKS.BANK_ACCOUNTS.SORT_CODE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('sort_code')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'BANKS.BANK_ACCOUNTS.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button
          [link]="['/bank-accounts/view']"
          [params]="{ id: dataItem.id }"
          *ngIf="accessService.hasAccess([], ['bank_accounts.show'])"
        >
        </app-preview-button>

        <app-edit-button *ngIf="accessService.hasAccess([], ['bank_accounts.show'])" (click)="edit(dataItem)">
        </app-edit-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([], ['bank_accounts.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
